import React from 'react';

import Table from 'components/Table';

import './styles.css';

const AgreementUserRow = ({label, agreementUser}) => (
  <Table.Row>
    <Table.Cell>{label}</Table.Cell>
    <Table.Cell>
      {agreementUser.fullName && (
        <div className="fullName">{agreementUser.fullName} -</div>
      )}
      <div className="email"> {agreementUser.email}</div>
    </Table.Cell>
  </Table.Row>
);

export default AgreementUserRow;
